import { useNavigate } from "react-router-dom"
import { useEffect } from "react"

import { SurveyResultsStorage } from "../../common/utils/SurveyResultsStorage"
import { SurveyResultsPage } from "../../../SelectionOfPsychologists/SurveyResultsPage"
import { useClientContext } from "../../../ClientAuthorization/common/ClientContext"

import { Competences } from "modules/NewClientSurvey/components/Competences"
import { ContactRequestPopup } from "modules/NewClientSurvey/components/ContactRequestPopup"
import { Cards } from "components/Cards"
import { formatText } from "modules/NewClientSurvey/components/StepThreeResults/helpers/formatText"
import { Layout } from "components"
import { Analytics } from "utils/analytics"

export function StepThreeResults() {
    const navigate = useNavigate()
    const [{ isVerified, userAccount }, { changeAccount }] = useClientContext()
    const surveyResults = SurveyResultsStorage
    useEffect(() => {
        if (!surveyResults.profiles.length) {
            navigate("/survey/psy", { replace: true })
        }
    }, [navigate, surveyResults])

    useEffect(() => {
        Analytics.survey_results()
        if (isVerified && surveyResults.profiles.length > 0) {
            changeAccount({
                completed_surveys: userAccount.completed_surveys + 1,
            })
        }
    }, [])

    if (!surveyResults.profiles.length) return null

    return (
        <Layout className="search-results">
            <SurveyResultsPage
                header={formatText(surveyResults.profiles.length)}
                body={
                    <>
                        <Competences
                            profiles={surveyResults.profiles}
                            title={surveyResults.title}
                            formOfWork={surveyResults.formOfWork}
                            sex={surveyResults.sex}
                            priceMin={surveyResults.priceMin}
                            priceMax={surveyResults.priceMax}
                            priceCategory={surveyResults.priceCategory}
                            slug={surveyResults.slug}
                            competences={surveyResults.reportedProblems}
                        />
                        <Cards
                            className="mt-5"
                            profiles={surveyResults.profiles}
                            showMorePsyCard={false}
                            showPsysStory={1}
                        />
                    </>
                }
            />
            <ContactRequestPopup onDone={() => undefined} psys={surveyResults.profiles} />
        </Layout>
    )
}
